// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5905":"css/admin-app.7009","9140":"css/app.7009"}[chunkId] + ".css";
};